import { Component } from '@angular/core';
import { adminMenuItems } from './sidebar.constant';
import { CommonModule, NgClass, NgOptimizedImage } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AdminAuthService } from '../../core/auth/admin-auth.service';

@Component({
  selector: 'app-sidebar',
  imports: [NgClass, RouterModule, MatTooltipModule, MatIconModule, CommonModule, NgOptimizedImage],
  templateUrl: './sidebar.html',
  styleUrl: './sidebar.scss',
})
export class Sidebar {
  menuItems: any[] = adminMenuItems;
  openSubMenuState: { [key: string]: boolean } = {};
  hoveredIndexes: { [key: string]: boolean } = {};

  constructor(
    private readonly authService: AdminAuthService,
    private readonly router: Router,
  ) {}

  isSubMenuOpen(index: string) {
    return this.openSubMenuState[index];
  }

  setHovered(index: string): void {
    this.hoveredIndexes[index] = true;
  }

  clearHovered(index: string): void {
    this.hoveredIndexes[index] = false;
  }

  toggleSubMenu(index: string, hasSubMenus: boolean) {
    if (!hasSubMenus) {
      return;
    }

    const parentKey = index.split('_')[0];
    Object.keys(this.openSubMenuState).forEach((key) => {
      if (!key.startsWith(parentKey)) {
        this.openSubMenuState[key] = false;
      }
    });

    // Toggle the clicked submenu
    this.openSubMenuState[index] = !this.openSubMenuState[index];
  }

  logout(): void {
    this.authService.logout();
    this.router.navigate(['/login']);
  }
}
